import { Box, Grid, Paper, Typography } from "@mui/material";
import { formatCurrency, formatDecimal } from "../../../../../util/number";

export const TabSoldDataCardItem = ({ title, data }) => {
  return (
    <Grid item xs={12} md={4} container gap={2}>
      <Typography variant="h6" fontWeight={"normal"}>
        {title}
      </Typography>
      <Box
        display={"flex"}
        flexDirection={"column"}
        p={1}
        justifyContent={"space-between"}
        component={Paper}
        elevation={1}
        variant="outlined"
        width="100%"
      >
        <Typography variant="subtitle1" fontWeight={"normal"}>
          <strong>Total</strong>
        </Typography>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
            marginTop: 2,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Valor vendido
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatCurrency(data?.vlrTotal || 0)}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Quantidade
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {data?.totalPedidos}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Ticket Médio
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatCurrency(data?.ticketMedio || 0)}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Lucratividade
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatDecimal(data?.lucratividade || 0)}%
          </Typography>
        </Box>
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        p={1}
        justifyContent={"space-between"}
        component={Paper}
        elevation={1}
        variant="outlined"
        width="100%"
      >
        <Typography variant="subtitle1" fontWeight={"normal"}>
          <strong>Vendas com cadastro</strong>
        </Typography>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
            marginTop: 2,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Valor vendido
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatCurrency(data?.vlrTotalComCadastro || 0)}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Quantidade
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {data?.totalPedidosComCadastro || 0}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Ticket Médio
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatCurrency(data?.ticketMedioComCadastro || 0)}
          </Typography>
        </Box>

        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Lucratividade
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatDecimal(data?.lucratividadeComCadastro || 0)}%
          </Typography>
        </Box>

        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Representatividade
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatDecimal(data?.representatividadeComCadastro || 0)}%
          </Typography>
        </Box>
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        p={1}
        justifyContent={"space-between"}
        component={Paper}
        elevation={1}
        variant="outlined"
        width="100%"
      >
        <Typography variant="subtitle1" fontWeight={"normal"}>
          <strong>Vendas sem cadastro</strong>
        </Typography>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
            marginTop: 2,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Valor vendido
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatCurrency(data?.vlrTotalSemCadastro || 0)}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Quantidade
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatCurrency(data?.totalPedidosSemCadastro || 0)}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Ticket Médio
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatCurrency(data?.ticketMedioSemCadastro || 0)}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Lucratividade
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatDecimal(data?.lucratividadeSemCadastro || 0)}%
          </Typography>
        </Box>

        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Representatividade
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatDecimal(data?.representatividadeSemCadastro || 0)}%
          </Typography>
        </Box>
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        p={1}
        justifyContent={"space-between"}
        component={Paper}
        elevation={1}
        variant="outlined"
        width="100%"
      >
        <Typography variant="subtitle1" fontWeight={"normal"}>
          <strong>Vendas com gestação cadastrada</strong>
        </Typography>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
            marginTop: 2,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Valor vendido
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatCurrency(data?.vlrTotalComGestacao || 0)}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Quantidade
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {data?.totalPedidosComGestacao || 0}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Ticket Médio
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatCurrency(data?.ticketMedioComGestacao || 0)}
          </Typography>
        </Box>

        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            Lucratividade
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatDecimal(data?.lucratividadeComGestacao || 0)}%
          </Typography>
        </Box>

        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={"normal"}>
            <Typography variant="subtitle1" fontWeight={"normal"} sx={{display: "block"}}>
              Representatividade{" "}
              <Typography variant="caption" fontWeight={"normal"} sx={{display: "block"}}>
                Em relação às vendas com cadastro
              </Typography>
            </Typography>
          </Typography>
          <Typography component={"h5"} variant="subtitle1">
            {formatDecimal(data?.representatividadeComGestacao || 0)}%
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
};
